import * as React from 'react'
import { Button } from 'evergreen-ui'

export const SmallerButton: typeof Button = (props) => {
  return <Button {...props} height='30px' paddingX='18px' />
}
